// End-user view — shows only the user's assigned peers with download

import { useEffect } from "react";
import { DataTable } from "../components/DataTable.js";
import { StatusBadge } from "../components/StatusBadge.js";
import { api, type Peer } from "../lib/api-client.js";
import { usePeerStore } from "../stores/peers.js";

export function MyPeers() {
	const { peers, loading, error, fetchPeers, user } = usePeerStore();

	useEffect(() => {
		fetchPeers();
	}, [fetchPeers]);

	// Non-admin users only see their own peers (filtered server-side)
	const myPeers = peers;

	const columns = [
		{
			key: "ip",
			header: "IP Address",
			render: (p: Peer) => <span className="mono">{p.ipAddress}</span>,
		},
		{
			key: "status",
			header: "Status",
			render: (p: Peer) => <StatusBadge status={p.status} />,
		},
		{
			key: "assignedAt",
			header: "Since",
			render: (p: Peer) =>
				p.assignedAt ? new Date(p.assignedAt).toLocaleDateString() : "—",
		},
		{
			key: "actions",
			header: "",
			render: (p: Peer) =>
				p.status === "assigned" ? (
					<button className="btn btn-sm btn-primary" onClick={() => api.downloadConfig(p.ipAddress)} type="button">
						Download Config
					</button>
				) : null,
		},
	];

	return (
		<div>
			<h1 className="page-title">My Peers</h1>

			{!user && (
				<div className="card">
					<p>
						Please <a href="/auth/login">log in</a> to view your peers.
					</p>
				</div>
			)}

			{error && <div className="card" style={{ color: "var(--color-error)" }}>{error}</div>}
			{loading && <div style={{ color: "var(--color-ink-muted)" }}>Loading...</div>}

			{user && myPeers.length === 0 && !loading && (
				<div className="card" style={{ textAlign: "center", padding: "var(--space-8)" }}>
					<p style={{ color: "var(--color-ink-muted)" }}>
						No peers assigned to you yet. Contact your administrator.
					</p>
				</div>
			)}

			{myPeers.length > 0 && (
				<DataTable columns={columns} data={myPeers} rowKey={(p) => p.ipAddress} />
			)}
		</div>
	);
}
